<template>
  <div>
    <view-table
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="sd/so"
        @reset="resetHandle"
        @delete="deleteHandle"
        @addOrEdit="addEditHandle"
        @select="selectHandle">
      <template slot="otherBtn">
        <el-upload
            style="float: left"
            action=""
            :http-request="ImportFile"
            :disabled="importLoading"
            :show-file-list="false">
          <el-button v-if="importAuth" style="margin-left: 10px" :loading="importLoading" type="primary">
            导入标准订单
          </el-button>
        </el-upload>
        <el-upload
            style="float: left"
            action=""
            :http-request="YWTImportFile"
            :disabled="YWTimportLoading"
            :show-file-list="false">
          <el-button v-if="importAuth" style="margin-left: 10px" :loading="YWTimportLoading" type="primary">
            导入英威腾订单
          </el-button>
        </el-upload>

        <el-select
            v-if="importAuth"
            slot="append"
            v-model.trim="importCustomerId"
            style="float: left;width: 220px;margin-left: 20px">
          <el-option label="武汉港迪技术股份有限公司" value="1963"/>
          <el-option label="现代（中国）电梯有限公司" value="2844"/>
          <el-option label="希望森兰科技股份有限公司" value="3174"/>
          <el-option label="思源清能电气电子有限公司" value="916"/>
          <el-option label="保定四方继保工程技术有限公司" value="29"/>
          <el-option label="深圳麦格米特电气股份有限公司" value="7122"/>
        </el-select>
        <el-upload
            slot="append"
            style="float: left"
            action=""
            :http-request="ImportCustomerFile"
            :disabled="importCustomerLoading"
            :show-file-list="false">
          <el-button v-if="importAuth" :loading="importCustomerLoading">
            导入订单
          </el-button>
        </el-upload>

        <el-button
            type="primary"
            style="margin-left: 10px"
            :loading="submitLoading"
            :disabled="!selection.length"
            @click="submitBatch">
          批量提交
        </el-button>
      </template>
      <template slot="adSearch">
        <div class="vm-search">
          <el-form :inline="true" :model="filter" label-width="65px" @keyup.enter.native="loadData(1)">
            <el-form-item label="订单编号">
              <el-input v-model.trim="filter.salesOrderNo" placeholder="请输入订单编号" clearable/>
            </el-form-item>
            <el-form-item label="订单类型">
              <el-select v-model.trim="filter.salesOrderCategory" clearable placeholder="请选择订单类型">
                <el-option label="销售订单" :value="10"/>
                <el-option label="赠送订单" :value="20"/>
                <el-option label="借用订单" :value="30"/>
                <el-option label="样品订单" :value="40"/>
              </el-select>
            </el-form-item>
            <el-form-item label="订单状态">
              <el-select v-model.trim="filter.status" clearable placeholder="请选择订单状态">
                <el-option label="草稿" :value="10"/>
                <el-option label="已提交" :value="20"/>
                <!--                <el-option label="作废" :value="999"/>-->
                <el-option label="退单" :value="12"/>
                <el-option label="通过" :value="100"/>
              </el-select>
            </el-form-item>
            <el-form-item label="客户名称">
              <el-input v-model.trim="filter.customer" placeholder="请输入客户名称" clearable/>
            </el-form-item>
            <el-form-item label="交货日期">
              <el-date-picker
                  v-model="deliveryDateRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  @change="dateRangeChange('deliveryDateRange', 'deliveryBeginDate', 'deliveryEndDate')"/>
            </el-form-item>
            <el-form-item label="制单日期">
              <el-date-picker
                  v-model="createDateRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  @change="dateRangeChange('createDateRange', 'orderBeginDate', 'orderEndDate')"/>
            </el-form-item>
            <el-form-item label="提交日期">
              <el-date-picker
                  v-model="submitDateRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  @change="dateRangeChange('submitDateRange', 'submitBeginDate', 'submitEndDate')"/>
            </el-form-item>
            <el-form-item label="制单人">
              <el-input v-model.trim="filter.creator" placeholder="请输入" clearable/>
            </el-form-item>
            <el-form-item label="ERP编号">
              <el-input v-model.trim="filter.erpSalesOrderNo" placeholder="请输入ERP订单编号" clearable/>
            </el-form-item>
            <el-form-item label="合同号">
              <el-input v-model.trim="filter.customerContractNo" placeholder="请输入合同号" clearable/>
            </el-form-item>
            <el-form-item label="项目名称">
              <el-input v-model.trim="filter.projectName" placeholder="请输入项目名称" clearable/>
            </el-form-item>
            <el-form-item label="物料编号">
              <el-input v-model.trim="filter.materialNo" placeholder="请输入物料编号" clearable/>
            </el-form-item>
            <el-form-item label="物料名称">
              <el-input v-model.trim="filter.materialName" placeholder="请输入物料名称" clearable/>
            </el-form-item>
            <el-form-item label="规格型号">
              <el-input v-model.trim="filter.specification" placeholder="请输入规格型号" clearable/>
            </el-form-item>
            <el-form-item label="备注">
              <el-input v-model.trim="filter.detailNote" placeholder="请输入备注" clearable/>
            </el-form-item>
          </el-form>
        </div>
      </template>
      <template slot="actionBtn" slot-scope="scope">
        <el-button
            v-if="limits.subAuth"
            type="primary"
            :disabled="scope.row.status !== 10"
            @click="submitHandle(scope.row)">
          提交
        </el-button>
        <el-button type="primary" @click="copyHandle(scope.row)">复制</el-button>
        <upload-file
            v-if="limits.downLoadAuth"
            ref="upload"
            style="display: inline-block;margin: 0 5px"
            :show-file-list="false"
            :loading="uploadLoading"
            :auth-index="authIndex"
            @upload-success="uploadSuccess($event,scope.row)"/>
      </template>
    </view-table>
    <sales-order-edit ref="salesOrderEdit" :options="options" @save-success="loadData"/>
  </div>
</template>

<script>
  import ViewTable from "@/components/ViewTable";
  import SalesOrderEdit from "./SalesOrderEdit";
  import loginUtil from "@/util/loginUtil";
  import UploadFile from "@/components/UploadFile";

  export default {
    name: "SalesOrderList",
    components: {ViewTable, UploadFile, SalesOrderEdit},
    data() {
      return {
        limits: {
          addAuth: this.$auth(4),
          editAuth: this.$auth(7),
          delAuth: this.$auth(9),
          subAuth: this.$auth(8),
          downLoadAuth: this.$auth(369),
        },
        authIndex: 369,
        importAuth: this.$auth(330),
        filter: {
          salesOrderNo: "",
          deliveryBeginDate: "",
          deliveryEndDate: "",
          orderBeginDate: "",
          orderEndDate: "",
          submitBeginDate: "",
          submitEndDate: "",
          customer: "",
          creator: "",
          salesOrderCategory: "",
          customerContractNo: "",
          projectName: "",
          erpSalesOrderNo: "",
          status: "",
          materialNo: "",
          materialName: "",
          specification: "",
          detailNote: "",
        },
        columnsProperty: [
          {
            key: "salesOrderNo",
            width: 130,
            align: "center",
            render: (h, params) => {
              return h(
                  "span",
                  {
                    style: {
                      color: "#2d8cf0",
                      cursor: "pointer",
                    },
                    on: {
                      click: () => {
                        this.$refs.salesOrderEdit.open(params.row, 0, true);
                      },
                    },
                  },
                  params.row.salesOrderNo,
              );
            },
          },
          {
            key: "salesOrderCategoryName",
            width: 100,
            align: "center",
          },
          {
            key: "customerName",
            width: 260,
            ellipsis: true,
          },
          {
            key: "totalAmount",
            width: 110,
            align: "center",
            render: (h, params) => {
              return h(
                  "span",
                  params.row.totalAmount === null ? "***" : params.row.totalAmount,
              );
            },
          },
          {
            key: "customerContractNo",
            width: 130,
            align: "center",
          },
          {
            key: "erpSalesOrderNo",
            width: 130,
            align: "center",
          },
          {
            key: "projectName",
            width: 180,
            tooltip: true,
          },
          {
            key: "cascadesName",
            width: 350,
          },
          {
            key: "deliveryDate",
            width: 110,
            align: "center",
            render: (h, params) => {
              return h("span", params.row.deliveryDate ? params.row.deliveryDate.slice(0, 10) : "");
            },
          },
          {
            key: "statusName",
            width: 80,
            align: "center",
          },
          {
            key: "contact",
            align: "center",
            width: 80,
          },
          {
            key: "telephone",
            align: "center",
            width: 130,
          },
          {
            key: "creatorName",
            align: "center",
            width: 80,
          },
          {
            key: "submitDate",
            align: "center",
            width: 160,
          },
          {
            key: "createDate",
            align: "center",
            width: 160,
          },
          {
            key: "action",
            align: "center",
            width: 320,
            slot: "action",
            fixed: "right",
          },
        ],
        options: [],
        submitDateRange: [],
        createDateRange: [],
        deliveryDateRange: [],
        importCustomerId: "1963",
        YWTimportLoading: false,
        importLoading: false,
        importCustomerLoading: false,
        uploadUrl: window.config.basicServerUrl + "sd/so/importContractFile",
        uploadHeaders: {Authorization: loginUtil.getToken()},
        disabled: false,
        importPdfLoading: false,
        uploadLoading: false,
        selection: [],
        submitLoading: false,
      };
    },

    watch: {
      "filter.deliveryBeginDate": {
        handler(newVal) {
          if (newVal) {
            this.deliveryDateRange = [];
            this.deliveryDateRange.push(this.filter.deliveryBeginDate);
            this.deliveryDateRange.push(this.filter.deliveryEndDate);
          }
        },
      },
      "filter.orderBeginDate": {
        handler(newVal) {
          if (newVal) {
            this.createDateRange = [];
            this.createDateRange.push(this.filter.orderBeginDate);
            this.createDateRange.push(this.filter.orderEndDate);
          }
        },
      },
      "filter.submitBeginDate": {
        handler(newVal) {
          if (newVal) {
            this.submitDateRange = [];
            this.submitDateRange.push(this.filter.submitBeginDate);
            this.submitDateRange.push(this.filter.submitEndDate);
          }
        },
      },
    },

    created() {
      this.getAreaOptions();
    },

    methods: {
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      dateRangeChange(timeRange, timeStart, timeEnd) {
        if (this[timeRange]) {
          this.filter[timeStart] = this[timeRange][0];
          this.filter[timeEnd] = this[timeRange][1];
        } else {
          this.filter[timeStart] = "";
          this.filter[timeEnd] = "";
        }
      },

      // 上传文件
      uploadSuccess(fileList, row) {
        if (fileList.length) {
          this.uploadLoading = true;
          const params = {
            itemType: 10,
            fileName: fileList[0].name,
            filePath: fileList[0].key,
            itemID: row.salesOrderId,
          };
          this.$http.post("basic", "attachments", params)
              .then((res) => {
                if (res.success) {
                  this.$message.success("上传成功");
                }
                this.uploadLoading = false;
              })
              .catch(() => {
                this.uploadLoading = false;
              });
        }
      },

      selectHandle(selection) {
        this.selection = selection;
      },

      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },

      addEditHandle(row) {
        this.$refs.salesOrderEdit.open(row);
      },

      // 获取所属区域列表
      getAreaOptions() {
        this.$http.get("basic", "districts/selectAllDistrict").then((res) => {
          if (res.success) {
            this.options = res.data;
          }
        });
      },

      // 删除
      deleteHandle(row) {
        this.$http.delete("basic", "sd/so", row.salesOrderId).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },

      // 提交
      submitHandle(row) {
        let ids = [row.salesOrderId];
        this.$confirm("确定提交吗?", "提示", {type: "warning"}).then(() => {
          this.$http.post("basic", `sd/so/submitBatch/${ids}`).then((resp) => {
            if (resp.success) {
              this.$message.success("提交成功");
              this.loadData();
            }
          });
        });
      },

      submitBatch() {
        let result = this.selection.some((item) => item.status !== 10);
        if (result) {
          this.$confirm("请选择订单状态为草稿的数据", "错误", {
            type: "error",
            showCancelButton: false,
          });
        } else {
          this.$confirm("确定提交吗?", "提示", {type: "warning"}).then(() => {
            let ids = [];
            this.selection.forEach((item) => {
              ids.push(item.salesOrderId);
            });
            this.submitLoading = true;
            this.$http
                .post("basic", `sd/so/submitBatch/${ids}`)
                .then((resp) => {
                  if (resp.success) {
                    this.$message.success("提交成功");
                    this.loadData();
                    this.selection = [];
                    this.submitLoading = false;
                  }
                })
                .catch(() => {
                  this.selection = [];
                  this.submitLoading = false;
                });
          });
        }
      },

      // 复制(只能复制状态为通过的数据)
      copyHandle(row) {
        this.$refs.salesOrderEdit.open(row, 1);
      },

      // 未提交、退单可以编辑删除
      otherAuth(row) {
        if (row.status === 10 || row.status === 12) {
          return {
            editAuth: false,
          };
        } else {
          return {
            editAuth: true,
          };
        }
      },

      //英威腾订单导入
      YWTImportFile(params) {
        this.YWTimportLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("file", params.file);
        formData.append("Authorization", loginUtil.getToken());
        this.$http
            .post("basic", "sd/so/importInvPurchaseOrder", formData)
            .then((res) => {
              if (res.success) {
                this.$message.success("上传成功");
                this.loadData(1);
              }
              this.YWTimportLoading = false;
            })
            .catch(() => {
              this.YWTimportLoading = false;
            });
      },

      //标准订单导入
      ImportFile(params) {
        this.importLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("file", params.file);
        formData.append("Authorization", loginUtil.getToken());
        this.$http
            .post("basic", "sd/so/importContractFile", formData)
            .then((res) => {
              if (res.success) {
                this.$message.success("上传成功");
                this.loadData(1);
              }
              this.importLoading = false;
            })
            .catch(() => {
              this.importLoading = false;
            });
      },

      //客户采购单导入
      ImportCustomerFile(params) {
        this.importCustomerLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("file", params.file);
        formData.append("Authorization", loginUtil.getToken());
        this.$http
            .post("basic", `sd/so/importCustomerFile/${this.importCustomerId}`, formData)
            .then((res) => {
              if (res.success) {
                this.$message.success("上传成功");
                this.loadData(1);
              }
              this.importCustomerLoading = false;
            })
            .catch(() => {
              this.importCustomerLoading = false;
            });
      },

      beforeAvatarUpload(file) {
        let fileName = file.name;
        let pos = fileName.lastIndexOf(".");
        let lastName = fileName.substring(pos, fileName.length);
        if (lastName.toLowerCase() !== ".xlsx" && lastName.toLowerCase() !== ".xls") {
          this.$message.error("请上传.xlsx或.xls文件类型");
        }
      },

      onExceed() {
        this.$message.error("一次只能导入一张表，请刷新后再导入");
      },
      handleSuccess(data) {
        if (data.success) {
          this.importLoading = false;
          this.disabled = false;
          this.$message.success("成功导入新的数据");
          this.loadData(1);
        } else {
          this.importLoading = false;
          this.disabled = false;
          this.$message.error(data.message);
        }
      },
      onProgress() {
        this.importLoading = true;
        this.disabled = true;
      },
      handlerError(err) {
        this.importLoading = false;
        this.disabled = false;
        err = JSON.parse(err.message);
        alert("导入失败\n" + err.message);
      },
    },
  };
</script>
